module.exports = __webpack_public_path__ + "static/img/zs.1783910470864.png";